/* global toastr */
export function raiseSuccessMessage(message) {
  if (!message) return;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (!toastr) {
    console.error('no toastr available to deliver success message:', message);
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  toastr.success(message);
}